import { default as domainGroupStatus } from './status/services'
import { default as domainGroupCategory } from './category/services'
import { default as domainGroupBase } from './base/services'
import { default as domainGroupIdentifier } from './identifier/services'
import { default as domainGroup } from './group/services'

export default {
    domainGroupStatus,
    domainGroupCategory,
    domainGroupBase,
    domainGroupIdentifier,
    domainGroup
}